import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import { fetchSegments } from '../actions'

import tableRowEpics from './TableRow/epics'
import {
  addSegmentError,
  addSegmentSuccess,
  deleteSegmentsError,
  deleteSegmentsSuccess,
  fetchTagsError,
  fetchTagsSuccess,
} from './actions'
import { ADD_ASYNC, DELETE_MANY_ASYNC, TAGS_REQUEST_ASYNC } from './constants'

const addSegmentEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(ADD_ASYNC.INITIATE).mergeMap(() => {
    const state = store.getState()
    return api.mailboxes
      .addSegment(state.partnerOptions.selectedCompany?.value, {
        name: state.form.AddSegmentForm.values.name,
        included_tags: state.mailboxes.segments.addNewSegment.includedTags.map((elem) => ({
          id: elem.value,
          name: elem.label,
        })),
        excluded_tags: state.mailboxes.segments.addNewSegment.excludedTags.map((elem) => ({
          id: elem.value,
          name: elem.label,
        })),
      })
      .map(({ response }) => {
        if (response.success) {
          store.dispatch(fetchSegments())
        }
        return addSegmentSuccess(response || {})
      })
      .catch((error) => Observable.of(epicsErrorHandler(addSegmentError, error)))
      .takeUntil(action$.ofType(ADD_ASYNC.CANCEL))
  })

const deleteSegmentsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DELETE_MANY_ASYNC.INITIATE).mergeMap(() =>
    api.mailboxes
      .deleteSegments(store.getState().partnerOptions.selectedCompany?.value, {
        name: 'Server hack',
        ids: Object.keys(store.getState().mailboxes.segments.selectedIds).map((elem) => ({
          id: elem,
        })),
      })
      .map(({ response }) => {
        if (response.success) {
          store.dispatch(fetchSegments())
        }
        return deleteSegmentsSuccess(response || {})
      })
      .catch((error) => Observable.of(epicsErrorHandler(deleteSegmentsError, error)))
      .takeUntil(action$.ofType(DELETE_MANY_ASYNC.CANCEL))
  )

const fetchTagsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(TAGS_REQUEST_ASYNC.INITIATE, FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return window.location.href.indexOf(URL_CONST.mailboxes.self) !== -1
      return true
    })
    .mergeMap(() =>
      api.mailboxes
        .getTags({
          companyId: store.getState().partnerOptions.selectedCompany?.value,
          allTags: false,
          page: store.getState().mailboxes.segments.tags.page,
          search: store.getState().mailboxes.segments.tags.search,
        })
        .map((response) => fetchTagsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchTagsError, error)))
        .takeUntil(action$.ofType(TAGS_REQUEST_ASYNC.CANCEL))
    )

export default combineEpics(tableRowEpics, addSegmentEpic, deleteSegmentsEpic, fetchTagsEpic)
